import { Event, EventEmitter, Element } from "@stencil/core";
import {
  Component,
  ComponentInterface,
  h,
  Host,
  Prop,
  State,
  Watch,
} from "@stencil/core";
// import {
//   getFormattedDate,
//   isDateDisabled,
//   daysInMonth,
//   getFirstDayOfMonth,
//   isCurrentMonth,
//   monthNames,
//   weekDays,
//   moveContainerPosition,
//   // getFormattedDateWithSlashes,
//   isStringDateValid,
//   getDateParts,
//   getLastDayOfMonth,
//   getDaysInNextMonth,
// } from "../../utils/datePickerUtils";

@Component({
  tag: "signet-date-range-advanced",
  styleUrl: "signet-date-range-picker-advanced.scss",
  shadow: false,
})
export class SignetDateRangeAdvanced implements ComponentInterface {
  @Element() el!: HTMLElement;
  // @State() startDateValue: Date | null = null;
  // @State() endDateValue: Date | null = null;
  // @State() dummyDateValue: Date | null = null;
  // @State() defaultDateValue: Date | null = null;
  // @State() formattedStartDateValue: string = "";
  // @State() formattedEndDateValue: string = "";
  // @State() currentMonth: number;
  // @State() currentYear: number;
  // @State() showCalendar: boolean = false;
  // @State() placeholder: string = "MM/DD/YYYY";
  // @State() isEndInputFocused: boolean = false;
  // @State() calendarContainerElement?: HTMLElement;
  // @State() startDateInputElement?: HTMLInputElement;
  // @State() endDateInputElement?: HTMLInputElement;
  // @State() isStartDateInputHovered?: boolean = false;
  // @State() isEndDateInputHovered?: boolean = false;
  // @State() yearRangeStart: number;
  // @State() view: "years" | "months" | "days" = "days";
  // @State() isStartDateValid: boolean;
  // @State() isEndDateValid: boolean;
  // @State() invalidStartDate: String = "";
  // @State() invalidEndDate: String = "";
  // @State() startDateError: boolean;
  // @State() endDateError: boolean;
  // @State() minDateValue: Date | null = null;
  // @State() maxDateValue: Date | null = null;

  // /**
  //  * The start date of the date range in string format (e.g., 'MM/DD/YYYY')
  //  */
  // @Prop() startDate: string;
  // /**
  //  * The end date of the date range in string format (e.g., 'MM/DD/YYYY')
  //  */
  // @Prop() endDate: string;
  // /**
  //  * A boolean indicating whether the date range picker is disabled
  //  */
  // @Prop() disabled: boolean = false;
  // /**
  //  * The locale for formatting the dates (e.g., 'en-US', 'en-GB')
  //  */
  // @Prop() locale: string = "en-US";
  // /**
  //  * A boolean indicating whether the end date should be automatically filled with the start date when a start date is selected
  //  */
  // @Prop() autoFillEndDate: boolean = false;
  // /**
  //  * The minimum selectable date the date range in string format (e.g., 'MM/DD/YYYY')
  //  */
  // @Prop() minDate: string;
  // /**
  //  * The maximun selectable date of the date range in string format (e.g., 'MM/DD/YYYY')
  //  */
  // @Prop() maxDate: string;
  // /**
  //  * The dummy date of the date range in string format (e.g., 'MM/DD/YYYY')
  //  */
  // @Prop() dummyDate: string;
  // /**
  //  * The default date value of the calendar (e.g., 'MM/DD/YYYY')
  //  */
  // @Prop() defaultValue: string;
  // /**
  //  *  A boolean indicating whether the date range picker is in an warning state. Toggles a YELLOW border around the input field.
  //  */
  // @Prop() warning: boolean;

  // /**
  //  * A boolean indicating whether the date range picker is in an error state. Toggles a RED border around the input field.
  //  */
  // @Prop() error: boolean;
  // /**
  //  * The label for the start date input field
  //  */
  // @Prop() startDateLabel: string = "Start Date";

  // /**
  //  * The label for the end date input field
  //  */
  // @Prop() endDateLabel: string = "End Date";
  // /**
  //  * A boolean indicating whether to show clear button
  //  */
  // @Prop() clearable: boolean = false;
  // /**
  //  * An event emitter that fires when the selected start or end date changes. It emits an object containing the startDate and endDate values
  //  */
  // @Event() changeEvent: EventEmitter<{
  //   startDate: string;
  //   endDate: string;
  // }>;
  // /**
  //  * An event emitter that fires when an invalid date is entered.
  //  * It emits an error object containing details about the invalid input.
  //  */
  // @Event() dateErrorEvent: EventEmitter<{
  //   message: string;
  //   invalidDate: string;
  //   field: "startDate" | "endDate";
  //   timestamp: Date;
  // }>;
  // /**
  //  * An event emitter that fires when the date range picker loses focus.
  //  */
  // @Event({ bubbles: true, composed: true })
  // handleBlur: EventEmitter<FocusEvent>;
  // /**
  //  * This event is emitted when the input element of the date picker gains focus. It can be used to perform actions or handle events when the date picker is focused, such as showing a calendar or changing the input format.
  //  */
  // @Event({ bubbles: true, composed: true })
  // handleFocus: EventEmitter<FocusEvent>;

  // @Watch("showCalendar")
  // @Watch("isEndInputFocused")
  // @Watch("startDateValue")
  // @Watch("defaultDateValue")
  // updateCalendarUiDefaultMonthAndYearValues() {
  //   let dateToDisplayInCalendarUI = new Date();

  //   if (this.defaultDateValue) {
  //     dateToDisplayInCalendarUI = this.defaultDateValue;
  //   }

  //   if (this.startDateValue) {
  //     dateToDisplayInCalendarUI = this.startDateValue;
  //   }

  //   this.currentMonth = dateToDisplayInCalendarUI.getMonth();
  //   this.currentYear = dateToDisplayInCalendarUI.getFullYear();
  //   this.yearRangeStart =
  //     Math.floor(dateToDisplayInCalendarUI.getFullYear() / 10) * 10;
  // }

  // @Watch("startDate")
  // updateStartDateValue(newValue: string) {
  //   this.startDateValue = newValue ? new Date(newValue) : null;
  // }

  // @Watch("endDate")
  // updateEndDateValue(newValue: string) {
  //   this.endDateValue = newValue ? new Date(newValue) : null;
  // }

  // @Watch("startDateValue")
  // setFormatToStartDateValue() {
  //   this.formattedStartDateValue = getFormattedDate(
  //     this.startDateValue,
  //     this.locale
  //   );

  //   if (this.startDateInputElement) {
  //     this.startDateInputElement.value = this.formattedStartDateValue;
  //   }
  // }

  // @Watch("endDateValue")
  // setFormatToEndDateValue() {
  //   this.formattedEndDateValue = getFormattedDate(
  //     this.endDateValue,
  //     this.locale
  //   );

  //   if (this.endDateInputElement) {
  //     this.endDateInputElement.value = this.formattedEndDateValue;
  //   }
  // }

  // @Watch("dummyDate")
  // updateDummyDateValue(newValue: string) {
  //   this.dummyDateValue = newValue ? new Date(newValue) : null;
  // }

  // @Watch("defaultValue")
  // updateDefaultValue(newValue: string) {
  //   this.defaultDateValue = newValue ? new Date(newValue) : null;
  // }

  // @Watch("minDate")
  // parseMinDate(val: string) {
  //   if (isStringDateValid(val, this.locale)) {
  //     const { day, month, year } = getDateParts(val, this.locale);
  //     // this.minDateValue = new Date(year, month - 1, day);
  //     this.minDateValue = new Date(
  //       parseInt(year, 10),
  //       parseInt(month, 10) - 1,
  //       parseInt(day, 10)
  //     );
  //   } else {
  //     this.minDateValue = null;
  //   }
  // }

  // @Watch("maxDate")
  // parseMaxDate(val: string) {
  //   if (isStringDateValid(val, this.locale)) {
  //     const { day, month, year } = getDateParts(val, this.locale);
  //     // this.maxDateValue = new Date(year, month - 1, day);
  //     this.maxDateValue = new Date(
  //       parseInt(year, 10),
  //       parseInt(month, 10) - 1,
  //       parseInt(day, 10)
  //     );
  //   } else {
  //     this.maxDateValue = null;
  //   }
  // }

//   private updatedDateValues() {
//     this.startDate = this.startDateValue
//       ? this.startDateValue.toISOString()
//       : "";
//     this.endDate = this.endDateValue ? this.endDateValue.toISOString() : "";
//
//     this.emitChangeEvent();
//
//     // Vue 2: emit 'input' event
//     this.el.dispatchEvent(new CustomEvent('input', {
//       bubbles: true,
//       composed: true,
//       detail: {
//         startDate: this.startDate,
//         endDate: this.endDate
//       }
//     }));
//
//     // Vue 3: emit 'update:modelValue' event
//     this.el.dispatchEvent(new CustomEvent('update:modelValue', {
//       bubbles: true,
//       composed: true,
//       detail: {
//         startDate: this.startDate,
//         endDate: this.endDate
//       }
//     }));
//   }

//   componentWillLoad() {
//     if (this.locale === "en-GB") {
//       this.placeholder = "DD/MM/YYYY";
//     } else if (this.locale === "en-US") {
//       this.placeholder = "MM/DD/YYYY";
//     }
//     this.parseMinDate(this.minDate);
//     this.parseMaxDate(this.maxDate);
//     this.updateStartDateValue(this.startDate);
//     this.updateEndDateValue(this.endDate);
//     this.updateDummyDateValue(this.dummyDate);
//     this.updateDefaultValue(this.defaultValue);
//     this.runValidationRules();
//   }

//   componentDidLoad() {
//     this.moveCalendarContainerToDocumentBody();
//     // Attach beforeinput to block non‑digits
//     if (this.startDateInputElement) {
//       this.startDateInputElement.addEventListener(
//         "beforeinput",
//         this.handleBeforeInput.bind(this)
//       );
//     }
//     if (this.endDateInputElement) {
//       this.endDateInputElement.addEventListener(
//         "beforeinput",
//         this.handleBeforeInput.bind(this)
//       );
//     }
//   }

//   private moveCalendarContainerToDocumentBody() {
//     if (this.calendarContainerElement) {
//       document.body.appendChild(this.calendarContainerElement);
//     }
//   }

//   private showNextMonth() {
//     if (this.currentMonth === 11) {
//       this.currentMonth = 0;
//       this.currentYear++;
//     } else {
//       this.currentMonth++;
//     }
//   }

//   private showPreviousMonth() {
//     if (this.currentMonth === 0) {
//       this.currentMonth = 11;
//       this.currentYear--;
//     } else {
//       this.currentMonth--;
//     }
//   }

//   private emitChangeEvent() {
//     this.changeEvent.emit({
//       startDate: getFormattedDate(this.startDateValue, this.locale),
//       endDate: getFormattedDate(this.endDateValue, this.locale),
//     });
//     // console.log(getFormattedDate(this.startDateValue, this.locale), "-", getFormattedDate(this.endDateValue, this.locale) );
//   }

//   private emitStartDateBlurEvent(event: FocusEvent) {
//     this.handleBlurEvent(event);
//     if (
//       this.invalidStartDate.length <= 9 &&
//       this.invalidStartDate.length > 0 &&
//       this.isEndInputFocused
//     ) {
//       this.isStartDateValid = false;
//     } else {
//       this.isStartDateValid = true;
//     }
//     this.handleBlur.emit(event);
//   }

//   private emitEndDateBlurEvent(event: FocusEvent) {
//     if (this.invalidEndDate.length <= 9 && this.invalidEndDate.length > 0) {
//       this.isEndDateValid = false;
//     } else {
//       this.isEndDateValid = true;
//     }

//     this.handleBlur.emit(event);
//   }

//   private emitFocusEvent(event: FocusEvent) {
//     const input = event.target as HTMLInputElement;
//     const isStartDateField = input === this.startDateInputElement;
//     const isEndDateField = input === this.endDateInputElement;
//     const previousValue = input.value;
//     if (isStringDateValid(previousValue, this.locale) && previousValue.length === 10) {
//       input.value = previousValue; 
//     } else {
//       if (isEndDateField) {
//         input.value = this.formattedEndDateValue;
//       } else if (isStartDateField) {
//         input.value = this.formattedStartDateValue;
//       }
//     }
//     setTimeout(() => {
//       input.setSelectionRange(input.value.length, input.value.length);
//     }, 0);

//     this.handleFocus.emit(event);
//   }

//   private handleBeforeInput(e: InputEvent) {
//     if (e.data && /\D/.test(e.data)) {
//       e.preventDefault();
//     }
//   }

//   private handleKeyDown(e: KeyboardEvent) {
//     const allowed = [
//       "Backspace","Delete",
//       "ArrowLeft","ArrowRight",
//       "Tab"
//     ];
//     if (!/^[0-9]$/.test(e.key) && !allowed.includes(e.key)) {
//       e.preventDefault();
//     }
//   }
  

//   private handleClearDates(value: string) {
//     let isSomeValueCleared = false;
//     let format = this.locale === "en-GB" ? "DD/MM/YYYY" : "MM/DD/YYYY";

//     if (value.trim().length === 0) {
//       this.formattedStartDateValue = format;
//       this.formattedEndDateValue = format;
//     }

//     if (
//       value.length === 0 &&
//       (!this.isEndInputFocused || this.isStartDateInputHovered)
//     ) {
//       this.startDateValue = null;

//       isSomeValueCleared = true;
//     }

//     if (
//       value.length === 0 &&
//       ((this.autoFillEndDate && !this.startDateValue) ||
//         this.isEndInputFocused ||
//         this.isEndDateInputHovered)
//     ) {
//       this.endDateValue = null;

//       isSomeValueCleared = true;
//     }

//     if (isSomeValueCleared) {
//       this.updatedDateValues();
//     }
//   }

//   private handleDateSelectedByKeyboard(event: Event) {
//     const input = event.target as HTMLInputElement;    
//     let cursorPos = input.selectionStart ?? 0;

//     const newChar = (event as InputEvent).data; 
//     if (!newChar || /\D/.test(newChar)) {
//       return;
//     }

//     // Define expected date format based on locale
//     let format = this.locale === "en-GB" ? "DD/MM/YYYY" : "MM/DD/YYYY";
//     let formattedArray = format.split("");

//     // Extract only numeric characters entered by the user
//     let inputChars = input.value.replace(/\D/g, "").split("");

//     if (cursorPos >= 3 && cursorPos <= 4 && inputChars.length === 7 && format === "MM/DD/YYYY") {
//       inputChars.splice(3, 0, "D");
//     }
//     if (cursorPos >= 0 && cursorPos <= 1 && inputChars.length === 7 && format === "MM/DD/YYYY") {
//       inputChars.splice(1, 0, "M");
//     }
//     if (cursorPos >= 3 && cursorPos <= 4 && inputChars.length === 7 && format === "DD/MM/YYYY") {
//       inputChars.splice(3, 0, "M");
//     }
//     if (cursorPos >= 0 && cursorPos <= 1 && inputChars.length === 7 && format === "DD/MM/YYYY") {
//       inputChars.splice(1, 0, "D");
//     }
//     // if (cursorPos >= 6 && cursorPos <= 9 && inputChars.length === 7) {
//     //   inputChars.splice(1, 0, "K");
//     // }
  
//     // Define fixed positions for MM, DD, YYYY
//     const mmIndex = format.startsWith("MM") ? 0 : 3;
//     const ddIndex = format.startsWith("DD") ? 0 : 3;
//     const yyyyIndex = 6;

//     // Ensure placeholders remain and only replace `M`, `D`, `Y` with typed numbers
//     let charIndex = 0;
//     for (let i = 0; i < formattedArray.length; i++) {
//         if (i === mmIndex || i === mmIndex + 1) {
//             formattedArray[i] = charIndex < inputChars.length ? inputChars[charIndex++] : "M";
//         } else if (i === ddIndex || i === ddIndex + 1) {
//             formattedArray[i] = charIndex < inputChars.length ? inputChars[charIndex++] : "D";
//         } else if (i >= yyyyIndex) {
//             // For YYYY, we need to handle 4 digits'
//             formattedArray[i] = charIndex < inputChars.length ? inputChars[charIndex++] : "Y";
//             // console.log(newChar, formattedArray[i], i, "CharIndex:", charIndex);
//             // formattedArray[i] = charIndex < inputChars.length ? inputChars[charIndex++] : "Y";
//         }

//     }
//     // Handle cursor position and input value update
//     if (cursorPos >= 6 && cursorPos <= 9) {
//       cursorPos = cursorPos + 1;
//       console.log("Carry Ment", cursorPos);
//       // inputChars[cursorPos] = newChar;
//       console.log("Input Chars", inputChars[cursorPos]);
//       // input.value = inputChars.join("");
//       let newCursorPos = cursorPos + 1;
//       if ([6, 9].includes(newCursorPos)) {
//         console.log("Who is this", newCursorPos);
//         newCursorPos++;
//         console.log("New Cursor Position", newCursorPos);
//       }
//       input.setSelectionRange(newCursorPos, newCursorPos);
//     }


//     if ( (cursorPos >= 0 && cursorPos <= 1) || (cursorPos >= 3 && cursorPos <= 4) || (cursorPos >= 6 && cursorPos <= 9)) {
//         inputChars[cursorPos] = newChar;
//         // input.value = inputChars.join("");
//         let newCursorPos = cursorPos + 1;
//         if ([2, 5].includes(newCursorPos)) {
//           newCursorPos++;
//         }
//         input.setSelectionRange(newCursorPos, newCursorPos);
//     }


//     // ✅ Set formatted value while keeping placeholders intact
//     input.value = formattedArray.join("");

//     console.log("Formatted Value", input.value);

//     // Preserve cursor position correctly
//     setTimeout(() => {
//         let newCursorPos = cursorPos;
//         if ([2, 5].includes(newCursorPos)) {
//             newCursorPos += 1; // Skip over slashes automatically
//         }
//         // if (input.value[newCursorPos - 1] === "/") {
//         //   newCursorPos--;
//         // }
//         input.setSelectionRange(newCursorPos, newCursorPos);
//     }, 0);

//     // Run your existing validation logic
//     this.handleClearDates(input.value);

//     if (!isStringDateValid(input.value, this.locale) && input.value.length === 10) {
//         const errorObject = {
//             message: `Invalid date entered: ${input.value}`,
//             invalidDate: input.value,
//             field: this.isEndInputFocused ? "endDate" : "startDate" as "endDate" | "startDate",
//             timestamp: new Date(),
//         };

//         console.error(errorObject);
//         this.dateErrorEvent.emit(errorObject);

//         if (this.isEndInputFocused) {
//             this.isEndDateValid = false;
//         } else {
//             this.isStartDateValid = false;
//         }
//     } else {
//         if (this.isEndInputFocused) {
//             this.isEndDateValid = true;
//         } else {
//             this.isStartDateValid = true;
//         }
//     }

//     if (isStringDateValid(input.value, this.locale)) {
//         const { day, month, year } = getDateParts(input.value, this.locale);

//         this.setDate(
//             parseInt(day, 10),
//             parseInt(month, 10) - 1,
//             parseInt(year, 10)
//         );

//         this.invalidEndDate = "";
//         this.invalidStartDate = "";
//     } else {
//         if (this.isEndInputFocused) {
//             this.invalidEndDate = input.value;
//         } else {
//             this.invalidStartDate = input.value;
//         }
//     }
// }




//   private handleDateDeleteByBackspace(event: KeyboardEvent) {
//     const input = event.target as HTMLInputElement;
//     if (!input || event.key !== "Backspace") return;

//     let cursorPosition = input.selectionStart ?? 0;
//     let selectionEnd = input.selectionEnd ?? 0;
//     let value = input.value;
//     let format = this.locale === "en-GB" ? "DD/MM/YYYY" : "MM/DD/YYYY";

//     // Define segment indices based on locale
//     let mmIndex = format.startsWith("MM") ? 0 : 3;
//     let ddIndex = format.startsWith("DD") ? 0 : 3;
//     let yyyyIndex = 6; // YYYY always starts at index 6

//     let newValue = value.split("");

//     // ✅ If user selects the whole input and presses Backspace, reset to placeholder format
//     if (cursorPosition === 0 && selectionEnd === value.length) {
//         input.value = format; // Restore full placeholder format
//         input.classList.add("placeholder-style"); // Apply placeholder color
//         input.setSelectionRange(0, 0); // Move cursor to the start
//         event.preventDefault();
//         this.handleClearDates(input.value);
//         return;
//     }

//     // ✅ If user selects MM, DD, or YYYY and presses Backspace, replace with placeholder
//     if (
//         (cursorPosition === mmIndex && selectionEnd === mmIndex + 2) || // MM selected
//         (cursorPosition === ddIndex && selectionEnd === ddIndex + 2) || // DD selected
//         (cursorPosition === yyyyIndex && selectionEnd === yyyyIndex + 4) // YYYY selected
//     ) {
//         if (cursorPosition === mmIndex) {
//             newValue[mmIndex] = "M";
//             newValue[mmIndex + 1] = "M";
//         } else if (cursorPosition === ddIndex) {
//             newValue[ddIndex] = "D";
//             newValue[ddIndex + 1] = "D";
//         } else if (cursorPosition === yyyyIndex) {
//             newValue[yyyyIndex] = "Y";
//             newValue[yyyyIndex + 1] = "Y";
//             newValue[yyyyIndex + 2] = "Y";
//             newValue[yyyyIndex + 3] = "Y";
//         }

//         input.value = newValue.join("");
//         input.classList.add("placeholder-style"); // Apply placeholder color
//         input.setSelectionRange(cursorPosition, cursorPosition);
//         event.preventDefault();
//         this.handleClearDates(input.value);
//         return;
//     }

//     // ✅ Normal Backspace behavior for single character deletion
//     if (cursorPosition > 0) {
//         let prevChar = newValue[cursorPosition - 1];

//         // Move cursor back if it lands on "/"
//         if (prevChar === "/") {
//             cursorPosition -= 1;
//         }

//         // ✅ Fix MM deletion
//         if (cursorPosition > mmIndex && cursorPosition <= mmIndex + 2) {
//           console.log("MM deletion");
//             newValue[cursorPosition - 1] = "M";
//             if (newValue[mmIndex] === "M" && newValue[mmIndex + 1] === "M") {
//                 cursorPosition = mmIndex + 1; // Keep cursor inside MM
//             }
//         }

//         // ✅ Fix DD deletion
//         else if (cursorPosition > ddIndex && cursorPosition <= ddIndex + 2) {
//             newValue[cursorPosition - 1] = "D";
//             if (newValue[ddIndex] === "D" && newValue[ddIndex + 1] === "D") {
//                 cursorPosition = ddIndex +1; // Keep cursor inside DD
//             }
//         }

//         // ✅ Fix YYYY deletion
//         else if (cursorPosition > yyyyIndex && cursorPosition <= yyyyIndex + 4) {
//             newValue[cursorPosition - 1] = "Y";
//             if (
//                 newValue[yyyyIndex] === "Y" &&
//                 newValue[yyyyIndex + 1] === "Y" &&
//                 newValue[yyyyIndex + 2] === "Y" &&
//                 newValue[yyyyIndex + 3] === "Y"
//             ) {
//                 cursorPosition = yyyyIndex; // Keep cursor inside YYYY
//             }
//         }

//         // Normal deletion (for numbers)
//         else {
//             newValue.splice(cursorPosition - 1, 1);
//         }

//         cursorPosition -= 1;
//     }

//     // ✅ Fix Cursor Jumping Issue: Delay Formatting Until User Finishes Typing
//     let finalCursorPosition = cursorPosition;
//     setTimeout(() => {
//         input.value = newValue.join(""); // Update value
//         input.setSelectionRange(finalCursorPosition, finalCursorPosition); // Restore cursor position
//     }, 0);

//     event.preventDefault();
//     this.handleClearDates(input.value);
// }

// // ✅ Only Format the Date When the User Leaves the Input (onBlur)
// private handleBlurEvent(event: FocusEvent) {
//   const input = event.target as HTMLInputElement;
//   const isStartDateField = input === this.startDateInputElement;
//   const isEndDateField = input === this.endDateInputElement;
//   const previousValue = input.value;
//   if (isStringDateValid(previousValue, this.locale) && previousValue.length === 10) {
//     input.value = previousValue; 
//   } else {
//     if (isEndDateField) {
//       input.value = this.formattedEndDateValue;
//     } else if (isStartDateField) {
//       input.value = this.formattedStartDateValue;
//     }
//   }
//   this.handleBlur.emit(event);
// }


//   private handleDateSelectedByUI(day: number, month: number, year: number) {
//     const date = new Date(year, month, day);

//     if (isDateDisabled(date, this.minDateValue, this.maxDateValue)) {
//       return;
//     }

//     this.setDate(day, month, year);
//   }

//   private setDate(day: number, month: number, year: number) {
//     const date = new Date(year, month, day);

//     if (this.isEndInputFocused) {
//       this.endDateValue = date;
//     } else {
//       this.startDateValue = date;
//     }

//     this.runValidationRules();
//     this.updatedDateValues();

//     if (!this.startDateValue) {
//       this.startDateInputElement.focus();
//     } else if (!this.endDateValue) {
//       this.endDateInputElement.focus();
//     } else {
//       this.closeCalendar();
//     }
//   }

//   private runValidationRules() {
//     if (this.autoFillEndDate && !this.endDateValue) {
//       this.endDateValue = this.startDateValue;
//     }

//     if (!this.startDateValue && this.endDateValue) {
//       this.endDateValue = null;
//     }

//     if (this.startDateValue > this.endDateValue) {
//       this.endDateValue = null;
//     }
//   }

//   private handleInputFocus() {
//     this.adjustCalendarContainerPosition();

//     this.calendarContainerElement.style.visibility = "visible";
//     this.showCalendar = true;
//   }

//   private adjustCalendarContainerPosition() {
//     if (!this.startDateInputElement || !this.calendarContainerElement) {
//       return;
//     }

//     moveContainerPosition(
//       this.startDateInputElement,
//       this.calendarContainerElement
//     );
//   }

//   private closeCalendar() {
//     this.calendarContainerElement.style.visibility = "hidden";
//     this.showCalendar = false;
//     this.view = "days";
//   }

//   private showStartDateClearButton() {
//     return (
//       this.clearable &&
//       this.startDateValue &&
//       this.isStartDateInputHovered &&
//       !this.disabled
//     );
//   }

//   private showEndDateClearButton() {
//     return (
//       this.clearable &&
//       this.endDateValue &&
//       this.isEndDateInputHovered &&
//       !this.disabled
//     );
//   }

//   private handleDocumentClick(event: MouseEvent) {
//     const target = event.target as HTMLElement;

//     if (!this.calendarContainerElement) {
//       return;
//     }

//     if (
//       !this.calendarContainerElement.contains(target) &&
//       document.activeElement !== this.startDateInputElement &&
//       document.activeElement !== this.endDateInputElement
//     ) {
//       this.closeCalendar();
//     }
//   }

//   connectedCallback() {
//     document.addEventListener("click", this.handleDocumentClick.bind(this));
//   }

//   disconnectedCallback() {
//     document.removeEventListener("click", this.handleDocumentClick.bind(this));
//   }

//   private handleDummyDate() {
//     this.startDateValue = this.dummyDateValue;
//     this.endDateValue = this.dummyDateValue;

//     this.runValidationRules();
//     this.updatedDateValues();
//     this.closeCalendar();
//   }

//   private showPreviousYearRange() {
//     this.yearRangeStart -= 10;
//   }

//   private showNextYearRange() {
//     this.yearRangeStart += 10;
//   }

//   private selectYear(year: number) {
//     this.currentYear = year;
//     this.view = "months";
//   }

//   private showYearSelector() {
//     this.view = "years";
//   }

//   private showMonthSelector() {
//     this.view = "months";
//   }

//   private showNextYear() {
//     this.currentYear++;
//   }

//   private showPreviousYear() {
//     this.currentYear--;
//   }

//   private selectMonth(monthIndex: number) {
//     this.currentMonth = monthIndex;
//     this.view = "days";
//   }

//   render() {
  
//     const startDateInputClassNames = {
//       disabled: this.disabled,
//       "start-date-error": this.error || this.isStartDateValid == false,
//       warning: this.warning,
//     };

//     const endDateInputClassNames = {
//       disabled: this.disabled,
//       "end-date-error": this.error || this.isEndDateValid == false,
//       warning: this.warning,
//     };

//     const daysInCurrentMonth = daysInMonth(this.currentMonth, this.currentYear);
//     const daysInNextMonth = getDaysInNextMonth(
//       this.currentMonth,
//       this.currentYear
//     );
//     const firstDayOfMonth = getFirstDayOfMonth(
//       this.currentMonth,
//       this.currentYear
//     );
//     const lastDayOfMonth = getLastDayOfMonth(
//       this.currentMonth,
//       this.currentYear
//     );
//     const yearRange = Array.from(
//       { length: 10 },
//       (_, index) => this.yearRangeStart + index
//     );

    // return (
  //     <Host>
  //       <div class="signet-date-range">
  //         <div class="input-container">
  //           <div
  //             class="input-label-container"
  //             onMouseEnter={() => {
  //               this.isStartDateInputHovered = true;
  //               this.isEndDateInputHovered = false;
  //             }}
  //             onMouseLeave={() => (this.isStartDateInputHovered = false)}
  //           >
  //             <label htmlFor="date" class="start-date-input-label">
  //               {this.startDateLabel}
  //             </label>
  //             <input
  //               type="text"
  //               inputMode="numeric"
  //               pattern="\d*"
  //               ref={(e) =>(this.startDateInputElement = e as HTMLInputElement)}
  //               value={this.formattedStartDateValue}
  //               onInput={(evt) => { this.handleDateSelectedByKeyboard(evt);}}
  //               onKeyDown={(evt) => this.handleDateDeleteByBackspace(evt as KeyboardEvent)}
  //               onFocus={(evt) => {
  //                 this.handleInputFocus();
  //                 this.emitFocusEvent(evt);
  //                 this.isEndInputFocused = false;
  //               }}
  //               onBlur={(evt) => this.emitStartDateBlurEvent(evt)}
  //               placeholder={this.placeholder}
  //               disabled={this.disabled}
  //               class={startDateInputClassNames}
  //             />
  //             {this.showStartDateClearButton() && (
  //               <span
  //                 class="input-clear-button"
  //                 onClick={() => this.handleClearDates("")}
  //               >
  //                 &#x2715;
  //               </span>
  //             )}
  //           </div>
  //           {/* <span>&ndash;</span> */}
  //           <div
  //             class="input-label-container"
  //             onMouseEnter={() => {
  //               this.isEndDateInputHovered = true;
  //               this.isStartDateInputHovered = false;
  //             }}
  //             onMouseLeave={() => (this.isEndDateInputHovered = false)}
  //           >
  //             <label htmlFor="date" class="end-date-input-label">
  //               {this.endDateLabel}
  //             </label>
  //             <input
  //               type="text"
  //               inputMode="numeric"
  //               pattern="\d*"
  //               ref={(e) => (this.endDateInputElement = e as HTMLInputElement)}
  //               value={this.formattedEndDateValue}
  //               onInput={(evt) => {this.handleDateSelectedByKeyboard(evt)}}
  //               onKeyDown={(evt) => this.handleDateDeleteByBackspace(evt as KeyboardEvent)}
  //               onFocus={(evt) => {
  //                 this.handleInputFocus();
  //                 this.emitFocusEvent(evt);
  //                 this.isEndInputFocused = true;
  //               }}
  //               onBlur={(evt) => {
  //                 this.emitEndDateBlurEvent(evt);
  //               }}
  //               placeholder={this.placeholder}
  //               disabled={this.disabled}
  //               class={endDateInputClassNames}
  //             />
  //             {this.showEndDateClearButton() && (
  //               <span
  //                 class="input-clear-button"
  //                 onClick={() => this.handleClearDates("")}
  //               >
  //                 &#x2715;
  //               </span>
  //             )}
  //           </div>
  //         </div>

  //         <div
  //           class="calendar-container-wrapper"
  //           ref={(e) => (this.calendarContainerElement = e as HTMLElement)}
  //           style={{ visibility: "hidden" }}
  //         >
  //           {this.dummyDate ? (
  //             <div class="shortcuts">
  //               <div
  //                 class="shortcut-button"
  //                 onClick={() => this.handleDummyDate()}
  //               >
  //                 Dummy Date
  //               </div>
  //             </div>
  //           ) : (
  //             ""
  //           )}
  //           <div class="calendar-container-content">
  //             {this.view === "years" ? (
  //               <div>
  //                 <div class="year-selector">
  //                   <signet-icon
  //                     class="calendar-icon left"
  //                     icon="chevron_left"
  //                     onClick={() => this.showPreviousYearRange()}
  //                   />
  //                   <span class="year-range">
  //                     {this.yearRangeStart} - {this.yearRangeStart + 9}
  //                   </span>
  //                   <signet-icon
  //                     class="calendar-icon right"
  //                     icon="chevron_right"
  //                     onClick={() => this.showNextYearRange()}
  //                   />
  //                 </div>
  //                 <div class="year-selector-content">
  //                   {yearRange.map((year) => (
  //                     <div
  //                       class="year-item"
  //                       onClick={() => this.selectYear(year)}
  //                     >
  //                       {year}
  //                     </div>
  //                   ))}
  //                 </div>
  //               </div>
  //             ) : this.view === "months" ? (
  //               <div>
  //                 <div class="year-selector">
  //                   <signet-icon
  //                     class="calendar-icon left"
  //                     icon="chevron_left"
  //                     onClick={() => this.showPreviousYear()}
  //                   />
  //                   <span class="year">{this.currentYear}</span>
  //                   <signet-icon
  //                     class="calendar-icon right"
  //                     icon="chevron_right"
  //                     onClick={() => this.showNextYear()}
  //                   />
  //                 </div>
  //                 <div class="month-selector">
  //                   {monthNames.map((month, index) => (
  //                     <div
  //                       class="month-item"
  //                       onClick={() => this.selectMonth(index)}
  //                     >
  //                       {month}
  //                     </div>
  //                   ))}
  //                 </div>
  //               </div>
  //             ) : (
  //               <div class="calendar">
  //                 <signet-icon
  //                   class="calendar-icon left"
  //                   icon="chevron_left"
  //                   onClick={() => this.showPreviousMonth()}
  //                 />
  //                 <h2 class="month-year">
  //                   <span
  //                     class="month"
  //                     onClick={() => this.showMonthSelector()}
  //                   >
  //                     {monthNames[this.currentMonth]}
  //                   </span>{" "}
  //                   <span class="year" onClick={() => this.showYearSelector()}>
  //                     {this.currentYear}
  //                   </span>
  //                 </h2>
  //                 <div class="weekdays">
  //                   {weekDays.map((day) => (
  //                     <div class="weekday">{day}</div>
  //                   ))}
  //                 </div>
  //                 <div class="days">
  //                   {Array.from({ length: firstDayOfMonth }, (_, index) => (
  //                     <div class="day blank" key={index}></div>
  //                   ))}
  //                   {Array.from({ length: daysInCurrentMonth }, (_, index) => {
  //                     const day = index + 1;
  //                     const date = new Date(
  //                       this.currentYear,
  //                       this.currentMonth,
  //                       day
  //                     );

  //                     console.log("Day:", day, "Date:", date.toDateString(), "isDisabled:", this.disabled, "min:", this.minDateValue, "max:", this.maxDateValue);

  //                     const isSelected =
  //                       (this.startDateValue &&
  //                         this.endDateValue &&
  //                         date >= this.startDateValue &&
  //                         date <= this.endDateValue) ||
  //                       (!this.endDateValue &&
  //                         this.startDateValue &&
  //                         date.getTime() === this.startDateValue.getTime());
  //                     const isBetween =
  //                       this.startDateValue &&
  //                       this.endDateValue &&
  //                       date > this.startDateValue &&
  //                       date < this.endDateValue;
  //                     const isSelectedFirstDay =
  //                       this.startDateValue &&
  //                       date.getMonth() === this.startDateValue.getMonth() &&
  //                       date.getFullYear() ===
  //                         this.startDateValue.getFullYear() &&
  //                       date.getDate() === this.startDateValue.getDate();
  //                     const isFirstDayAfterStart =
  //                       this.startDateValue &&
  //                       date.getMonth() === this.startDateValue.getMonth() &&
  //                       date.getFullYear() ===
  //                         this.startDateValue.getFullYear() &&
  //                       date.getDate() === this.startDateValue.getDate() + 1;
  //                     const isSelectedLastDay =
  //                       this.endDateValue &&
  //                       date.getMonth() === this.endDateValue.getMonth() &&
  //                       date.getFullYear() ===
  //                         this.endDateValue.getFullYear() &&
  //                       date.getDate() === this.endDateValue.getDate();
  //                     const isLastDayBeforeEnd =
  //                       this.endDateValue &&
  //                       date.getMonth() === this.endDateValue.getMonth() &&
  //                       date.getFullYear() ===
  //                         this.endDateValue.getFullYear() &&
  //                       date.getDate() === this.endDateValue.getDate() - 1;
  //                     return (
  //                       <div
  //                         class={`day ${
  //                           isCurrentMonth(
  //                             day,
  //                             this.currentMonth,
  //                             this.currentYear
  //                           )
  //                             ? "current-day"
  //                             : ""
  //                         } ${isSelected ? "selected-day" : ""}
                          
  //                         ${isSelectedFirstDay ? "selected-first-day" : ""}
                          
  //                         ${isSelectedLastDay ? "selected-last-day" : ""}

  //                         ${this.disabled ? "disabled-day" : ""}

  //                         ${isBetween ? "between-day" : ""} 
                          
  //                         ${
  //                           isFirstDayAfterStart ? "first-day-after-start" : ""
  //                         } 
                          
  //                         ${isLastDayBeforeEnd ? "last-day-before-end" : ""} 
                          
  //                         ${
  //                           isDateDisabled(
  //                             new Date(
  //                               this.currentYear,
  //                               this.currentMonth,
  //                               day
  //                             ),
  //                             this.minDateValue,
  //                             this.maxDateValue
  //                           )
  //                             ? "disabled-day"
  //                             : ""
  //                         }`}
  //                         key={day}
  //                         data-day={day}
  //                         data-month={this.currentMonth}
  //                         data-year={this.currentYear}
  //                         onClick={() =>
  //                           this.handleDateSelectedByUI(
  //                             day,
  //                             this.currentMonth,
  //                             this.currentYear
  //                           )
  //                         }
  //                       >
  //                         {day}
  //                       </div>
  //                     );
  //                   })}
  //                 </div>
  //               </div>
  //             )}

  //             {this.view == "years" ? (
  //               <span></span>
  //             ) : this.view == "months" ? (
  //               <span></span>
  //             ) : (
  //               <div class="divider" />
  //             )}

  //             {this.view === "years" ? (
  //               <span></span>
  //             ) : this.view === "months" ? (
  //               <span></span>
  //             ) : (
  //               <div class="calendar">
  //                 <h2 class="month-year">
  //                   <span
  //                     class="month"
  //                     onClick={() => this.showMonthSelector()}
  //                   >
  //                     {monthNames[(this.currentMonth + 1) % 12]}
  //                   </span>{" "}
  //                   <span class="year" onClick={() => this.showYearSelector()}>
  //                     {this.currentMonth === 11
  //                       ? this.currentYear + 1
  //                       : this.currentYear}
  //                   </span>
  //                 </h2>

  //                 <div class="weekdays">
  //                   {weekDays.map((day) => (
  //                     <div class="weekday">{day}</div>
  //                   ))}
  //                 </div>
  //                 <div class="days">
  //                   {Array.from(
  //                     { length: lastDayOfMonth === 6 ? 0 : lastDayOfMonth + 1 },
  //                     (_, index) => (
  //                       <div class="day blank" key={index}></div>
  //                     )
  //                   )}
  //                   {Array.from({ length: daysInNextMonth }, (_, index) => {
  //                     const day = index + 1;
  //                     const date = new Date(
  //                       this.currentYear,
  //                       this.currentMonth + 1,
  //                       day
  //                     );
  //                     const isSelected =
  //                       (this.startDateValue &&
  //                         this.endDateValue &&
  //                         date >= this.startDateValue &&
  //                         date <= this.endDateValue) ||
  //                       (!this.endDateValue &&
  //                         this.startDateValue &&
  //                         date.toDateString() ===
  //                           this.startDateValue.toDateString());
  //                     const isBetween =
  //                       this.startDateValue &&
  //                       this.endDateValue &&
  //                       date > this.startDateValue &&
  //                       date < this.endDateValue;

  //                     const isSelectedFirstDay =
  //                       this.startDateValue &&
  //                       date.getMonth() === this.startDateValue.getMonth() &&
  //                       date.getFullYear() ===
  //                         this.startDateValue.getFullYear() &&
  //                       date.getDate() === this.startDateValue.getDate();

  //                     const isSelectedLastDay =
  //                       this.endDateValue &&
  //                       date.getMonth() === this.endDateValue.getMonth() &&
  //                       date.getFullYear() ===
  //                         this.endDateValue.getFullYear() &&
  //                       date.getDate() === this.endDateValue.getDate();
  //                     const isFirstDayAfterStart =
  //                       this.startDateValue &&
  //                       date.getMonth() === this.startDateValue.getMonth() &&
  //                       date.getFullYear() ===
  //                         this.startDateValue.getFullYear() &&
  //                       date.getDate() === this.startDateValue.getDate() + 1;
  //                     const isLastDayBeforeEnd =
  //                       this.endDateValue &&
  //                       date.getMonth() === this.endDateValue.getMonth() &&
  //                       date.getFullYear() ===
  //                         this.endDateValue.getFullYear() &&
  //                       date.getDate() === this.endDateValue.getDate() - 1;


  //                     return (
  //                       <div
  //                         class={`day ${
  //                           isCurrentMonth(
  //                             index + 1,
  //                             (this.currentMonth + 1) % 12,
  //                             this.currentMonth === 11
  //                               ? this.currentYear + 1
  //                               : this.currentYear
  //                           )
  //                             ? "current-day"
  //                             : ""
  //                         } ${isSelected ? "selected-day" : ""} ${
  //                           isBetween ? "between-day" : ""
  //                         } 
                          
  //                         ${isSelectedFirstDay ? "selected-first-day" : ""}
                          
  //                         ${isSelectedLastDay ? "selected-last-day" : ""}

  //                         ${this.disabled ? "disabled-day" : ""}
                          
  //                         ${
  //                           isFirstDayAfterStart ? "first-day-after-start" : ""
  //                         } ${
  //                           isLastDayBeforeEnd ? "last-day-before-end" : ""
  //                         } ${
  //                           isDateDisabled(
  //                             new Date(
  //                               this.currentYear,
  //                               this.currentMonth + 1,
  //                               day
  //                             ),
  //                             this.minDateValue,
  //                             this.maxDateValue
  //                           )
  //                             ? "disabled-day"
  //                             : ""
                            
  //                         }`}
  //                         key={day}
  //                         data-day={day}
  //                         data-month={this.currentMonth + 1}
  //                         data-year={this.currentYear}
  //                         onClick={() =>
  //                           this.handleDateSelectedByUI(
  //                             day,
  //                             this.currentMonth + 1,
  //                             this.currentYear
  //                           )
  //                         }
  //                       >
  //                         {day}
  //                       </div>
  //                     );
  //                   })}
  //                 </div>
  //                 <signet-icon
  //                   class="calendar-icon right"
  //                   icon="chevron_right"
  //                   onClick={() => this.showNextMonth()}
  //                 />
  //               </div>
  //             )}
  //           </div>
  //         </div>
  //       </div>
  //     </Host>
    // );
  // }

}
